import { Component } from '@angular/core';

@Component({
    selector: 'explore',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ExploreComponent {}
